import {Stack} from '@chakra-ui/react';
import {TitledSection} from 'components/layouts/aside-layout/components';
import {PreOrder} from 'components/pages/checkout';
import {FC} from 'react';
import {TranslationKeys} from 'translations';
import {DeliveryMethodEnum, IPreOrderData} from 'types';

interface Props {
  method: DeliveryMethodEnum;
  onChange: (method: DeliveryMethodEnum) => void;
  t: (term: TranslationKeys) => string;
  provider_is_open?: boolean;
  preOrder?: IPreOrderData;
  providerDeliveredTime?: string;
  providerClosed: boolean;
  accepts_preorders: boolean;
}

export const DeliveryMethod: FC<Props> = ({
  t,
  provider_is_open,
  preOrder,
  providerDeliveredTime,
  providerClosed,
  accepts_preorders,
}) => {
  return (
    <TitledSection title={t('DELIVERY_METHOD')}>
      <Stack direction={['column', 'row']} spacing={['15px', '10px']}>
        <PreOrder
          preOrder={preOrder}
          provider_is_open={provider_is_open}
          providerDeliveredTime={providerDeliveredTime}
          restaurantClosed={providerClosed}
          accepts_preorders={accepts_preorders}
        />
      </Stack>
    </TitledSection>
  );
};
